import React from 'react';

export type VerificationRequestFormContextValue = {
  isEmployeeInfoLoading: boolean;
  setIsEmployeeInfoLoading: (isEmployeeInfoLoading: boolean) => void;

  isEmployeeExists: boolean;
  setIsEmployeeExists: (isEmployeeExists: boolean) => void;

  isEmployeeFrozen: boolean;
  setIsEmployeeFrozen: (isEmployeeFrozen: boolean) => void;

  isEmployersInfoLoading: boolean;
  setIsEmployersInfoLoading: (isEmployersInfoLoading: boolean) => void;

  isEmployersHavePayrollsInfo: boolean;
  setIsEmployersHavePayrollsInfo: (isEmployersHavePayrollsInfo: boolean) => void;

  isPermissiblePurposesLoading: boolean;
  setIsPermissiblePurposesLoading: (isPermissiblePurposesLoading: boolean) => void;

  isTotalChargeLoading: boolean;
  setIsTotalChargeLoading: (isTotalChargeLoading: boolean) => void;

  isFormInfoLoading: boolean;

  resetData: () => void;
  startSubmitting: () => void;
  stopSubmitting: () => void;
};

export const VerificationRequestFormContext = React.createContext(
  {} as VerificationRequestFormContextValue,
);
